import React from 'react';
import { Play, Loader2 } from 'lucide-react';

interface TestSearchButtonProps {
  onTestSearch: () => void;
  isLoading: boolean;
}

export function TestSearchButton({ onTestSearch, isLoading }: TestSearchButtonProps) {
  return (
    <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg shadow-md p-6 text-white">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold mb-2">Try Demo Search</h3>
          <p className="text-primary-100 text-sm">
            Run a sample search with predefined job requirements to see the system in action
          </p>
        </div>
        <button
          onClick={onTestSearch}
          disabled={isLoading}
          className="bg-white text-primary-600 px-4 py-2 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2 transition-colors"
        >
          {isLoading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>Running...</span>
            </>
          ) : (
            <>
              <Play className="w-4 h-4" />
              <span>Run Demo</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
